// extracted by mini-css-extract-plugin
export default {"page":"UpayTransactionsPage_page__q1QqN","header":"UpayTransactionsPage_header__Il+1W","title":"UpayTransactionsPage_title__OIrBA","subtitle":"UpayTransactionsPage_subtitle__QDc8R"};